/** Detection for the native app shell (apps/mobile — Capacitor WKWebView).
 *
 *  The shell appends this token to its user agent via `appendUserAgent` in
 *  `apps/mobile/capacitor.config.ts` — the two literals must stay in sync
 *  (no shared package spans the web app and the Capacitor config compile).
 *  WKWebView otherwise mimics mobile Safari byte-for-byte, so this token is
 *  the ONLY signal the web app has that it is rendering inside the store
 *  app. Guards that key on it: the login-only billing surface (App Store
 *  fee-scope compliance), the OAuth deep-link return flow, and
 *  shell-divergent copy (#979 recovery card).
 */
export const SHELL_UA_TOKEN = "MedceptorShell";

/** True when the given user-agent string identifies the native app shell.
 *  Pass `navigator.userAgent` (client) or the `user-agent` header (server).
 */
export function isShellUserAgent(userAgent: string | null | undefined): boolean {
  return userAgent?.includes(SHELL_UA_TOKEN) ?? false;
}
